module.exports = __webpack_public_path__ + "assets/5e5b2805032093345277532cc4bad407.mp3";